import { useQuery } from "@tanstack/react-query";
import {
	type GetStraightenerKpisParams,
	getStraightenerKpis,
	getStraightenerKpisPickers,
} from "../repositories/StraightenerKpisRepository";

type UseStraightenerKpisParams = Omit<GetStraightenerKpisParams, "signal">;

export const useStraightenerKpisData = ({
	start,
	end,
	productSizeId,
	crewId,
	productionShift,
}: UseStraightenerKpisParams) =>
	useQuery({
		queryKey: [
			"straightenerKpis",
			start,
			end,
			productSizeId,
			crewId,
			productionShift,
		],
		queryFn: ({ signal }) =>
			getStraightenerKpis({
				start,
				end,
				productSizeId,
				crewId,
				productionShift,
				signal,
			}),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});

export const useStraightenerKpisPickers = () =>
	useQuery({
		queryKey: ["straightenerKpisPickers"],
		queryFn: ({ signal }) => getStraightenerKpisPickers(signal),
		staleTime: Number.POSITIVE_INFINITY,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
